import { render, staticRenderFns } from "./badges-dashboard-component.vue?vue&type=template&id=04eabbf6&scoped=true&"
import script from "./badges-dashboard-component.vue?vue&type=script&lang=ts&"
export * from "./badges-dashboard-component.vue?vue&type=script&lang=ts&"
import style0 from "./badges-dashboard-component.vue?vue&type=style&index=0&id=04eabbf6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04eabbf6",
  null
  
)

export default component.exports